// export const apiLink = "http://localhost:5050";
// export const apiLink = 'http://161.97.146.42:5050';
export const apiLink = "https://monkfish-app-k6pxl.ondigitalocean.app";
